<template>
  <div class="payment-account-card  _akord _disabled">
    <BasePreloader v-if="card.balance === '-'"/>
    <img src="@/assets/img/payment/card-akord.svg"
         alt="card-akord"
         class="payment-account-card__img">
    <div class="payment-account-card__content">
      <div class="payment-account-card__info">
        <div @click.stop.prevent="onToggle"
             class="payment-account-card__info-toggle">
          <BaseSvg name="ico-info"/>
        </div>
        <transition name="dropdown">
          <div v-show="isOpenDropdown"
               v-click-out="onClose"
               class="payment-account-card__info-dropdown">
            <button @click.prevent="update()"
                    class="payment-account-card__info-dropdown-link">
              <BaseSvg name="ico-refresh"/>
              {{$tPayment('Update balance')}}
            </button>
            <button @click.prevent="$vModal.open('payment-account-requisites',card)"
                    class="payment-account-card__info-dropdown-link">
              <BaseSvg name="ico-doc-details"/>
              {{$tPayment('Details')}}
            </button>
          </div>
        </transition>
      </div>
      <div class="payment-account-card__row">
        <div class="payment-account-card__number">
          {{ card?card.number:'' }}
        </div>
        <div class="payment-account-card__date">
          {{ card?card.expire:'' }}
        </div>
      </div>
      <div class="payment-account-card__value">
        {{ card?card.balance:'' }} EUR
      </div>
    </div>
  </div>
</template>

<script>
  import {http} from '@/axios'

  export default {
    name: 'PaymentAccountCardAkord',
    props: {
      requestData: Object,
      card: {}
    },
    data() {
      return {
        isOpenDropdown: false,
      }
    },
    methods: {
      onToggle() {
        this.isOpenDropdown = !this.isOpenDropdown
      },
      onClose() {
        this.isOpenDropdown = false
      },
      update() {
        this.card.balance = '-'
        http.get('/api/jobian-pay/get-accord-balance')
            .then(({data}) => {
              this.card = data
              this.onClose();
            })
      }
    },
    created() {
      this.update()
    }
  }
</script>

<style lang="less">

</style>
